const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const crearCorte = async (data) => {
  try {
    const response = await fetch(`${API_URL}/cortes-inventario-lenceria/crear`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al generar el corte');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en crearCorte:', error);
    throw error;
  }
};

export const fetchCortes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/cortes-inventario-lenceria/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los cortes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchCortes:', error);
    throw error;
  }
};

export const fetchCorteById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/cortes-inventario-lenceria/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener el corte');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchCorteById:', error);
    throw error;
  }
};

export const fetchMovimientosCorte = async (id, filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/cortes-inventario-lenceria/${id}/movimientos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los movimientos del corte');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientosCorte:', error);
    throw error;
  }
};

export const deleteCorte = async (id) => {
  try {
    const response = await fetch(`${API_URL}/cortes-inventario-lenceria/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al eliminar el corte');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en deleteCorte:', error);
    throw error;
  }
};
